import { DangerousEnvVarsBanner } from "@/components/navigation/DangerousEnvVarsBanner";
import { EngineImageOverrideWarning } from "@/components/navigation/EngineImageOverrideWarning";
import { useGlobalAppState } from "@/utils/app-state";
import React, { useCallback } from "react";

export interface LayoutWarningBannersProps {
  loggedIn?: boolean;
}

export const LayoutWarningBanners: React.FC<LayoutWarningBannersProps> = ({ loggedIn }) => {
  const {
    state: { warningBannersCollapsed },
    updateState,
  } = useGlobalAppState();

  const setCollapsed = useCallback(
    (collapsed: boolean) => {
      updateState({ warningBannersCollapsed: collapsed });
    },
    [updateState],
  );

  if (!loggedIn) {
    return null;
  }

  if (warningBannersCollapsed) {
    return (
      <div className="flex justify-end gap-x-1">
        <EngineImageOverrideWarning collapsed onToggleCollapsed={setCollapsed} />
        <DangerousEnvVarsBanner collapsed onToggleCollapsed={setCollapsed} />
      </div>
    );
  }

  return (
    <>
      <EngineImageOverrideWarning onToggleCollapsed={setCollapsed} />
      <DangerousEnvVarsBanner onToggleCollapsed={setCollapsed} />
    </>
  );
};
